import { ClassEnrollment } from '@/models/ClassEnrollment';
import List from '@/models/List';
import { Program } from '@/models/Program';
import { ProgramPaginationData } from '@/models/ProgramPaginationData';
import { AxiosError } from 'axios';
import { CourseStudentView } from '../list/types';

export enum ProgramTypes {
    GET_PROGRAMS_REQUEST = '@program/GET_PROGRAMS_REQUEST',
    GET_PROGRAMS_SUCCESS = '@program/GET_PROGRAMS_SUCCESS',
    GET_PROGRAMS_FAILURE = '@program/GET_PROGRAMS_FAILURE',
    GET_PROGRAM_REQUEST = '@program/GET_PROGRAM_REQUEST',
    GET_PROGRAM_SUCCESS = '@program/GET_PROGRAM_SUCCESS',
    GET_PROGRAM_FAILURE = '@program/GET_PROGRAM_FAILURE',
    GET_PROGRAM_CLEAR = '@program/GET_PROGRAM_CLEAR',
    CREATE_PROGRAM_REQUEST = '@program/CREATE_PROGRAM_REQUEST',
    CREATE_PROGRAM_SUCCESS = '@program/CREATE_PROGRAM_SUCCESS',
    CREATE_PROGRAM_FAILURE = '@program/CREATE_PROGRAM_FAILURE',
    UPDATE_PROGRAM_REQUEST = '@program/UPDATE_PROGRAM_REQUEST',
    UPDATE_PROGRAM_SUCCESS = '@program/UPDATE_PROGRAM_SUCCESS',
    UPDATE_PROGRAM_FAILURE = '@program/UPDATE_PROGRAM_FAILURE',
    CREATE_PROGRAM_COURSE_REQUEST = '@programClass/CREATE_PROGRAM_COURSE_REQUEST',
    CREATE_PROGRAM_COURSE_SUCCESS = '@programClass/CREATE_PROGRAM_COURSE_SUCCESS',
    CREATE_PROGRAM_COURSE_FAILURE = '@programClass/CREATE_PROGRAM_COURSE_FAILURE',
    CREATE_PROGRAM_COURSE_CLEAR = '@programClass/CREATE_PROGRAM_COURSE_CLEAR',
    REORDER_PROGRAM_COURSE_REQUEST = '@program/REORDER_PROGRAM_COURSE_REQUEST',
    REORDER_PROGRAM_COURSE_SUCCESS = '@program/REORDER_PROGRAM_COURSE_SUCCESS',
    REORDER_PROGRAM_COURSE_FAILURE = '@program/REORDER_PROGRAM_COURSE_FAILURE',
    GET_PROGRAM_COURSES_LIST_REQUEST = '@program/GET_PROGRAM_COURSES_LIST_REQUEST',
    GET_PROGRAM_COURSES_LIST_SUCCESS = '@program/GET_PROGRAM_COURSES_LIST_SUCCESS',
    GET_PROGRAM_COURSES_LIST_FAILURE = '@program/GET_PROGRAM_COURSES_LIST_FAILURE',
    CATEGORIZED_SUCCESS = '@program/CATEGORIZED_SUCCESS',
    ADD_PROGRAM_BY_CATEGORY = '@program/ADD_PROGRAM_BY_CATEGORY',
    REMOVE_PROGRAM_COURSES_REQUEST = '@program/REMOVE_PROGRAM_COURSES_REQUEST',
    REMOVE_PROGRAM_COURSES_SUCCESS = '@program/REMOVE_PROGRAM_COURSES_SUCCESS',
    REMOVE_PROGRAM_COURSES_FAILURE = '@program/REMOVE_PROGRAM_COURSES_FAILURE',
    GET_PROGRAM_LIST_STUDENT_VIEW_REQUEST = '@program/GET_PROGRAM_LIST_STUDENT_VIEW_REQUEST',
    LAST_PUBLISHED_SUCCESS = '@program/LAST_PUBLISHED_SUCCESS',
    LAST_PUBLISHED_CLEAR = '@program/LAST_PUBLISHED_CLEAR',
    IN_PROGRESS_SUCCESS = '@program/IN_PROGRESS_SUCCESS',
    IN_PROGRESS_CLEAR = '@program/IN_PROGRESS_CLEAR',
    ESSENTIALS_SUCCESS = '@program/ESSENTIALS_SUCCESS',
    ESSENTIALS_CLEAR = '@program/ESSENTIALS_CLEAR',
    GET_PROGRAM_LIST_STUDENT_VIEW_FAILURE = '@program/IN_PROGRESS_SUCCESS',
    ADD_COURSE_IN_PROGRAM_REQUEST = '@program/ADD_COURSE_IN_PROGRAM_REQUEST',
    ADD_COURSE_IN_PROGRAM_SUCCESS = '@program/ADD_COURSE_IN_PROGRAM_SUCCESS',
    ADD_COURSE_IN_PROGRAM_FAILURE = '@program/ADD_COURSE_IN_PROGRAM_FAILURE',
    GET_PROGRAM_CLASS_STUDENT_VIEW_REQUEST = '@program/GET_PROGRAM_CLASS_STUDENT_VIEW_REQUEST',
    GET_PROGRAM_CLASS_STUDENT_VIEW_SUCESS = '@program/GET_PROGRAM_CLASS_STUDENT_VIEW_SUCCESS',
    GET_PROGRAM_CLASS_STUDENT_VIEW_FAILURE = '@program/GET_PROGRAM_CLASS_STUDENT_VIEW_FAILURE',
    PUBLISH_PROGRAM_REQUEST = '@program/PUBLISH_PROGRAM_REQUEST',
    PUBLISH_PROGRAM_SUCCESS = '@program/PUBLISH_PROGRAM_SUCCESS',
    PUBLISH_PROGRAM_FAILURE = '@program/PUBLISH_PROGRAM_FAILURE',
    GET_PROGRAM_PREREQUISITES_REQUEST = '@program/GET_PROGRAM_PREREQUISITES_REQUEST',
    GET_PROGRAM_PREREQUISITES_SUCCESS = '@program/GET_PROGRAM_PREREQUISITES_SUCCESS',
    GET_PROGRAM_PREREQUISITES_FAILURE = '@program/GET_PROGRAM_PREREQUISITES_FAILURE',
    SET_PROGRAM_PREREQUISITES_REQUEST = '@program/SET_PROGRAM_PREREQUISITES_REQUEST',
    SET_PROGRAM_PREREQUISITES_SUCCESS = '@program/SET_PROGRAM_PREREQUISITES_SUCCESS',
    SET_PROGRAM_PREREQUISITES_FAILURE = '@program/SET_PROGRAM_PREREQUISITES_FAILURE',
    CLEAR_PROGRAM_CLASS_STUDENT_VIEW = '@program/CLEAR_PROGRAM_CLASS_STUDENT_VIEW',
    CLEAR_PROGRAM = '@program/CLEAR_PROGRAM',
    SET_PROGRAM_READY_REQUEST = '@program/SET_PROGRAM_READY_REQUEST',
    SET_PROGRAM_READY_SUCCESS = '@program/SET_PROGRAM_READY_SUCCESS',
    SET_PROGRAM_READY_FAILURE = '@program/SET_PROGRAM_READY_FAILURE',
    SEARCHED_REQUEST = '@program/SEARCHED_REQUEST',
    SEARCHED_FAILURE = '@program/SEARCHED_FAILURE',
    SEARCHED_SUCCESS = '@program/SEARCHED_SUCCESS',
    SEARCHED_CLEAR = '@program/SEARCHED_CLEAR',
    UPDATE_PROGRAM_CLASS_STUDENT_VIEW_REQUEST = '@program/UPDATE_PROGRAM_CLASS_STUDENT_VIEW_REQUEST',
    UPDATE_PROGRAM_CLASS_STUDENT_VIEW_SUCCESS = '@program/UPDATE_PROGRAM_CLASS_STUDENT_VIEW_SUCCESS',
    UPDATE_PROGRAM_CLASS_STUDENT_VIEW_FAILURE = '@program/UPDATE_PROGRAM_CLASS_STUDENT_VIEW_FAILURE',
    COMPLETED_CLEAR = '@program/COMPLETED_CLEAR',
    COMPLETED_SUCCESS = '@program/COMPLETED_SUCCESS',
    FAVORITE_SUCCESS = '@program/FAVORITE_SUCCESS',
    FAVORITES_CLEAR = '@program/FAVORITES_CLEAR',
    REMOVE_PROGRAM_FROM_LIST = '@program/REMOVE_PROGRAM_FROM_LIST',
    INCREASE_PROGRAM_VIEWS_REQUEST = '@program/INCREASE_PROGRAM_VIEWS_REQUEST',
    INCREASE_PROGRAM_VIEWS_SUCCESS = '@program/INCREASE_PROGRAM_VIEWS_SUCCESS',
    INCREASE_PROGRAM_VIEWS_FAILURE = '@program/INCREASE_PROGRAM_VIEWS_FAILURE',
    TRAININGS_CLEAR = '@program/TRAININGS_CLEAR',
    TRAININGS_SUCCESS = '@program/TRAININGS_SUCCESS',
}

export interface Programs {
    programs: Program[];
}

export interface ProgramState {
    data: Programs;
    programData: Program;
    prerequisitesEnabled: boolean;
    loading: boolean;
    hasError: boolean;
    error?: AxiosError;
    success: boolean;
    courseAdded: boolean;
    courseRemoved: boolean;
    lastRemovedCourseId?: number;
    courses: List[];
    listData: {
        [key: string]: ListProgramClassStudentView;
        listLastPublishedStudentView: ListProgramClassStudentView;
        listInProgressStudentView: ListProgramClassStudentView;
        listSearchResultStudentView: ListProgramClassStudentView;
        listCompletedStudentView: ListProgramClassStudentView;
        listFavoriteStudentView: ListProgramClassStudentView;
        listEssentialStudentView: ListProgramClassStudentView;
        listTrainingsEnrolledStudentView: ListProgramClassStudentView;
    };
    currentProgramClassStudentView: ProgramClassStudentView;
}

export interface ListProgramClassStudentView {
    list: ProgramClassStudentView[];
    total: number;
    totalToExpire: number;
    loading: boolean;
}

export interface ProgramClassStudentView {
    classEnrollment: ClassEnrollment;
    courseStudentViews: CourseStudentView[];
}

export interface ProgramSearchedRequest {
    term: string;
    moduleIds: string;
    pagination: ProgramPaginationData;
    locales?: string;
}
